import { useKnockMsTeamsClient as T } from "../context/KnockMsTeamsProvider.mjs";
import { useMemo as _, useCallback as m } from "react";
import "../../i18n/context/KnockI18nProvider.mjs";
import { TENANT_OBJECT_COLLECTION as k } from "@knocklabs/client";
import { useKnockClient as d } from "../../core/context/KnockProvider.mjs";
import "fast-deep-equal";
import "date-fns";
import "swr/infinite";
import "swr";
const p = "https://login.microsoftonline.com/organizations/adminconsent", h = "/providers/ms-teams/authenticate";
function S(r, c) {
  const e = d(), {
    setConnectionStatus: t,
    knockMsTeamsChannelId: n,
    tenantId: o,
    setActionLabel: i
  } = T(), a = _(() => e.host + h, [e.host]), u = m(() => {
    const s = {
      state: JSON.stringify({
        redirect_url: c,
        ms_teams_tenant_object: {
          object_id: o,
          collection: k
        },
        channel_id: n,
        public_key: e.apiKey,
        user_token: e.userToken
      }),
      client_id: r,
      redirect_uri: a
    };
    return `${p}?${new URLSearchParams(s)}`;
  }, [c, o, n, e.apiKey, e.userToken, r, a]), l = m(async () => {
    i(null), t("disconnecting");
    try {
      const s = await e.msTeams.revokeAccessToken({
        tenant: o,
        knockChannelId: n
      });
      t(s === "ok" ? "disconnected" : "error");
    } catch {
      t("error");
    }
  }, [t, e.msTeams, o, n, i]);
  return {
    buildMsTeamsAuthUrl: u,
    disconnectFromMsTeams: l
  };
}
export {
  S as default
};
//# sourceMappingURL=useMsTeamsAuth.mjs.map
